import React, { useState } from 'react';
import { QrCode, Eye, Download, Copy, Check, X, ArrowLeft } from 'lucide-react';
import ModuleBarcode from './ModuleBarcode';
import { trainingModules } from '../data/trainingData';

const ModuleBarcodeManager = ({ onBack }) => {
  const [selectedModule, setSelectedModule] = useState(null);
  const [showAllBarcodes, setShowAllBarcodes] = useState(false);

  const handleModuleSelect = (module) => {
    setSelectedModule(module);
    setShowAllBarcodes(false);
  };

  const handleShowAll = () => {
    setShowAllBarcodes(true);
    setSelectedModule(null);
  };

  const handleClose = () => {
    setSelectedModule(null);
    setShowAllBarcodes(false);
  };

  return (
    <div className="barcode-manager">
      <div className="barcode-manager-header">
        <div className="barcode-header-left">
          <button onClick={onBack} className="btn btn-secondary">
            <ArrowLeft size={16} style={{ marginRight: '8px' }} />
            Back to Admin
          </button>
        </div>
        
        <div className="barcode-header-center">
          <div className="barcode-manager-title">
            <QrCode size={24} />
            <h2>Module Barcodes</h2>
          </div>
          <p className="barcode-manager-description">
            Generate QR codes for each training module. Users can scan these codes to directly access specific modules.
          </p>
        </div>
        
        <div className="barcode-header-right">
          {/* Empty div to balance the layout */}
        </div>
      </div>

      {!selectedModule && !showAllBarcodes && (
        <div className="barcode-actions">
          <button 
            onClick={handleShowAll}
            className="btn btn-primary"
          >
            <Eye size={16} />
            View All Barcodes
          </button>
        </div>
      )}

      {showAllBarcodes && (
        <div className="all-barcodes">
          <div className="all-barcodes-header">
            <h3>All Module Barcodes</h3>
            <button onClick={handleClose} className="btn btn-secondary">
              <X size={16} />
              Close
            </button>
          </div>
          
          <div className="barcodes-grid">
            {trainingModules.map((module) => (
              <div key={module.id} className="barcode-card">
                <div className="barcode-card-header">
                  <div className="module-icon">
                    {module.icon}
                  </div>
                  <div className="module-info">
                    <h4 className="module-title">{module.title}</h4>
                    <p className="module-description">{module.description}</p>
                  </div>
                </div>
                
                <div className="barcode-card-content">
                  <ModuleBarcode 
                    moduleId={module.id} 
                    moduleTitle={module.title}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {selectedModule && (
        <div className="single-barcode">
          <div className="single-barcode-header">
            <button onClick={handleClose} className="btn btn-secondary">
              <X size={16} />
              Back to List
            </button>
            <h3>{selectedModule.title} - Barcode</h3>
          </div>
          
          <div className="single-barcode-content">
            <ModuleBarcode 
              moduleId={selectedModule.id} 
              moduleTitle={selectedModule.title}
            />
          </div>
        </div>
      )}

      {!selectedModule && !showAllBarcodes && (
        <div className="modules-list">
          <h3>Select a Module to Generate Barcode</h3>
          <div className="modules-grid">
            {trainingModules.map((module) => (
              <div 
                key={module.id} 
                className="module-item"
                onClick={() => handleModuleSelect(module)}
              >
                <div className="module-icon">
                  {module.icon}
                </div>
                <div className="module-details">
                  <h4 className="module-title">{module.title}</h4>
                  <p className="module-description">{module.description}</p>
                  <div className="module-meta">
                    <span className="module-duration">{module.duration} min</span>
                    <span className="module-difficulty">{module.difficulty}</span>
                  </div>
                </div>
                <div className="module-action">
                  <QrCode size={20} />
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ModuleBarcodeManager;
